import { Action } from '../actions';
import { transformContest } from '../contest/contest.transformers';
import { mergeMultipleObjects } from '../helpers';

export function threadContestsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'threads') {
        const contextDetails = action.payload.result.context_details;
        if (!contextDetails || !contextDetails.contests) {
          return state;
        }

        return mergeMultipleObjects<'threadContests'>(
          state,
          Object.values(contextDetails.contests).map(transformContest),
        );
      } else if (action.payload.type === 'threadContests') {
        const { result } = action.payload;
        if (result.contests) {
          return mergeMultipleObjects<'threadContests'>(
            state,
            Object.values(result.contests).map(transformContest),
          );
        }
        return state;
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/datastore/thread/threadContest.reducer.ts